<div class="">
  Copyright 2026 -
  <a href="#" class="underline" (click)="openTermsAndConditions($event)"
    >Medinbox Legal stuff</a
  >
</div>
